<template>
    <div class="classification" ref="container">
        <el-table :data="tableData" :height="tableHeight" style="width: 100%">
            <el-table-column prop="date" label="企业信息" >
                <div slot-scope="scope">
                    <div>企业名称：{{scope.row.sellerName}}</div>
                    <div>企业税号：{{scope.row.sellerTaxpayerId}}</div>
                    <div>税务机关代码：{{scope.row.taxAuthoritiesCode}}</div>
                    <div>税务机关名称：{{scope.row.taxAuthoritiesName}}</div>
                    <div>地区编码：{{scope.row.zipCode}}</div>
                    <div>开票人手机号：{{scope.row.mobile}}</div>
                </div>
            </el-table-column>
            <el-table-column label="纳税人类型" width="120">
                <div slot-scope="scope">
                    {{ formatTaxPayerType(scope.row.taxPayerType)}}
                </div>
            </el-table-column>
            <el-table-column prop="address" label="组织类型" width="120">
                <div slot-scope="scope">
                    {{ formatOrgType(scope.row.orgType)}}
                </div>
            </el-table-column>
            <el-table-column  label="开通业务" width="120">
                <div slot-scope="scope">销项开票</div>
            </el-table-column>
            <el-table-column prop="address" label="税控设备类型" width="120">
                <div slot-scope="scope">
                    {{ formatTaxDriverType(scope.row.taxDriverType)}}
                </div>
            </el-table-column>
            <el-table-column prop="mobile" label="用户名" width="120">
            </el-table-column>
            <el-table-column prop="name" label="开户行">
                <div slot-scope="scope">
                    <div>开户行：{{scope.row.sellerBank}}</div>
                    <div>银行帐号：{{scope.row.sellerAccount}}</div>
                    <div>注册电话：{{scope.row.sellerTel}}</div>
                    <div>注册地址：{{scope.row.province}}{{scope.row.city}}{{scope.row.area}}{{scope.row.address}}</div>
                </div>
            </el-table-column>
            <el-table-column label="操作" width="120">
                <div slot-scope="scope" >
                    <span v-if="scope.row.status" class="openBtn" style="color: #595959;">已开通</span>
                    <div v-else class="openBtn" style="color: red;" @click="confirmAction(scope.row.sellerShopId)">开通</div>
                </div>
            </el-table-column>
        </el-table>
    </div>
</template>
  
<script>
import {  getInvoiceVerifyList,getOrgType, getZipCode, getTaxPayerType, getTaxDriverType, elephantInvoiceOpen } from "@/api/invoiceOps";
import lodash from 'lodash'
export default {
    data() {
        return {
            tableHeight:500,
            tableData: [],
            sellerShopId:'',
            shopName:'',
            zipCodeList: [],
            orgTypeList: [],
            taxPayerTypeList:[],//纳税人类型
            taxDriverTypeList:[],//
            isLoading:false
        }
    },
    mounted(){
        this.$nextTick(()=>{

            this.tableHeight = this.$refs['container'].offsetHeight || 500
        })
        this.getData()
        
    },
    methods: {
        confirmAction(shopId){
            this.$confirm('确定开通发票?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
            .then(() => {
                this.isLoading = true;
                this.openAction(shopId)
            })
            .catch(() => {
            
            })
        },
        async openAction (shopId){
            const obj = {
                shopId:shopId
            }
            try {
                const resp = await elephantInvoiceOpen(obj)
                setTimeout(() => {
                    this.isLoading = false    
                }, 1500);
                if (resp) {
                    this.$message.success('开通成功')
                    this.getDataDetail()
                }
            } catch (error) {
                this.isLoading = false
            }
        },
        async getData(){
            await this.getTaxDriverTypeList()
            await this.getTaxPayerTypeList()
            await this.getOrgList()
            await this.getZipCodeList()
            this.getDataDetail()
        },
        async getTaxDriverTypeList (){
            const resp = await getTaxDriverType()
            if (resp ) {
                let tmp = []
                for (const key in resp) {
                    if (Object.hasOwnProperty.call(resp, key)) {
                        const element = resp[key];
                        tmp.push({
                            codeValue: key,
                            codeText: element
                        })
                    }
                }
                this.taxDriverTypeList = tmp
            }
        },
        async getTaxPayerTypeList (){
            const resp = await getTaxPayerType()
            if (resp) {
                let tmp = []
                for (const key in resp) {
                    if (Object.hasOwnProperty.call(resp, key)) {
                        const element = resp[key];
                        tmp.push({
                            codeValue: key,
                            codeText: element
                        })
                    }
                }
                this.taxPayerTypeList = tmp
            }
        },
        async getOrgList() {
            const resp = await getOrgType()
            if (resp) {
                let tmp = []
                for (const key in resp) {
                    if (Object.hasOwnProperty.call(resp, key)) {
                        const element = resp[key];
                        tmp.push({
                            codeValue: key,
                            codeText: element
                        })
                    }
                }
                this.orgTypeList = tmp
            }
        },
        async getZipCodeList() {
            const resp = await getZipCode()
            if (resp) {
                resp.forEach((e) => {
                    e['value'] = `${e.name} / ${e.code}`
                })
                this.zipCodeList = resp
            }
        },
        async getDataDetail (){
            const resp = await getInvoiceVerifyList({})
            if (resp && resp.length) {
                this.tableData = resp
            }else{
                this.tableData = []   
            }
        },
        formatTaxPayerType(type){
            // 匹配纳税人类型
           const result = lodash.find(this.taxPayerTypeList,((e)=>{ return e.codeValue == type }))
           return result.codeText || ''
        },
        formatOrgType(type){
            // 匹配组织类型
           const result = lodash.find(this. orgTypeList,((e)=>{ return e.codeValue == type }))
           return result.codeText || ''
        },
        formatTaxDriverType(type){
            // 匹配税控设备类型
           const result = lodash.find(this.taxDriverTypeList,((e)=>{ return e.codeValue == type }))
           return result.codeText || ''
        },
      
    }
}
</script>
<style lang="scss" scoped>
.openBtn{
    cursor: pointer;
}
</style>